import React from "react";
import Grid from "@material-ui/core/Grid";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";
import "../invoiceprint.css"

function FooterDH(props) {
    const { found } = props;
    const styf = { fontWeight: "bold", fontSize: "0.8rem", direction: "rtl", };
    const styfE = { fontWeight: "bold", fontSize: "0.7rem", };
    const styfC = { fontSize: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular", paddingBottom: "0.3rem" };
    return (
        <Grid item container
            style={{ padding: 5, fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm" }}
        >
            <Grid
                item
                container
                xs={12}
                style={{ fontWeight: "bold", }}
            >
                <Grid item xs={12} container  >
                    <Grid container item xs={6} style={{ textAlign: "reft", fontFamily: "Amiri-Regular", direction: "ltr" }}  >
                        <div style={styfC}>{found.Disc1_footer_en}</div>
                        <div style={styfE}>{found.Disc2_footer_en}</div>
                        <div style={styfE}>{found.Disc3_footer_en}</div>
                        <div style={styfE}>{found.Disc4_footer_en}</div>

                    </Grid>

                    <Grid container item xs={6} style={{ textAlign: "right", fontFamily: "Amiri-Regular", direction: "rtl" }}>
                        <div style={styfC}>{found.Disc1_footer_ar}</div>
                        <div style={styf}>{found.Disc2_footer_ar}</div>
                        <div style={styf}>{found.Disc3_footer_ar}</div>
                        <div style={styf}>{found.Disc4_footer_ar}</div>
                    </Grid>

                    <Grid item  container   xs={12} className={"invoice-footerar"} style={styleFooterNotesAr} >
                        {found.BillNotes}
                    </Grid>

                </Grid>

            </Grid>

        </Grid>

    );
}
export default FooterDH;

